module.exports = __webpack_public_path__ + "img/credit-score-managment-icon.6a6e35cb.svg";